import { RootState } from '../store';
import { Note } from '../../shared/types/notesTypes';
import { ProjectState } from '../../shared/types/projectTypes';

export const selectCurrentProject = (state: RootState) => state.project.currentProject;
export const selectIsLoadingProject = (state: RootState) => state.project.loading;
export const selectHasNewProject = (state: RootState) => state.project.hasNewProject;
export const selectProjectError = (state: RootState) => state.project.error;
export const selectScriptData = (state: RootState) => state.project.scriptData;
export const selectIsLoadingScript = (state: RootState) => state.project.loading;
export const selectIsCreatingProject = (state: RootState) => state.project.isCreatingProject;
export const selectRecentProjects = (state: RootState) => state.project.recentProjects;
export const selectIsLoadingSharing = (state: RootState) => state.project.isLoadingSharing;
export const selectImageData = (state: RootState) => state.project.imageData;
export const selectIsRefining = (state: RootState) => state.project.isRefining;
export const selectRefinedText = (state: RootState) => state.project.refinedText;
export const selectTextSuggestions = (state: RootState) => state.project.textSuggestions;
export const selectIsTextSuggesting = (state: RootState) => state.project.isTextSuggesting;
export const selectReferences = (state: RootState) => state.project.references;
export const selectIsSearchingReferences = (state: RootState) =>
    state.project.isSearchingReferences;
export const selectPostSuccess = (state: RootState) => state.project.postSuccess;
export const selectSelectedSocialMedia = (state: RootState) => state.project.selectedSocialMedia;
export const selectVideoState = (state: { project: ProjectState }) => state.project.videoState;
export const selectVideo = (state: { project: ProjectState }) => state.project.videoData;
export const selectGenerationMode = (state: { project: ProjectState }) =>
    state.project.generatonMode;
export const selectInputPrompt = (state: { project: ProjectState }) => state.project.inputPrompt;
export const selectMultiplePosts = (state: RootState) => state.project.multiplePosts;
export const selectPostsToPublish = (state: RootState) => state.project.postsToPublish;
